export default class WindowScroll {
  constructor($window, $document) {
    'ngInject';

    Object.assign(this, { $window, $document });
  }

  get x() {
    return 'scrollX' in this.$window
      ? this.$window.scrollX
      : this.$document[0].documentElement.scrollLeft;
  }

  get y() {
    return 'scrollY' in this.$window
      ? this.$window.scrollY
      : this.$document[0].documentElement.scrollTop;
  }
}
